import { render, staticRenderFns } from "./AnaliseProduto4ComparativoFaturamento.vue?vue&type=template&id=080b03f6&scoped=true&"
import script from "./AnaliseProduto4ComparativoFaturamento.vue?vue&type=script&lang=js&"
export * from "./AnaliseProduto4ComparativoFaturamento.vue?vue&type=script&lang=js&"
import style0 from "./AnaliseProduto4ComparativoFaturamento.vue?vue&type=style&index=0&id=080b03f6&scoped=true&lang=css&"
import style1 from "./AnaliseProduto4ComparativoFaturamento.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080b03f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VIcon,VRow})
